/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"

import { appleAppStoreId, links } from "src/constants"
import useSiteMetadata from "src/legacy/hooks/useSiteMetadata"

interface OwnProps {
  canonicalUrl?: string
  lang?: string
  jsonLD: string
  meta?: []
  ogDescription?: string
  ogImage?: string
  ogTitle?: string
  ogType?: string
  title?: string
}

export type SEOProps = OwnProps

const SEO: React.FC<SEOProps> = ({
  canonicalUrl,
  jsonLD,
  lang = "en",
  meta = [],
  ogDescription = "",
  ogImage = "",
  ogTitle,
  ogType = "website",
  title,
}): React.ReactElement => {
  const siteMetadata = useSiteMetadata()
  const metaDescription = ogDescription || siteMetadata.description
  const baseImageUrl = ogImage?.split("?")[0]
  const defaultOGImage =
    "https://images.prismic.io/join-parachute/ZgXq3ct2UUcvBQ-f_homepage-og.png"
  const googleFontsLink = links.googleFonts
  const pageTitle = ogTitle || title
  const defaultTitle = pageTitle ? ` | ${siteMetadata.title}` : ""
  const canonical = canonicalUrl

  return (
    <>
      <html lang="en-US" />
      <title>
        {pageTitle}
        {defaultTitle}
      </title>
      {appleAppStoreId && (
        <meta name="apple-itunes-app" content={`app-id=${appleAppStoreId}`} />
      )}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {ogDescription ||
        (metaDescription && (
          <meta
            name="og:description"
            content={ogDescription || metaDescription}
          />
        ))}
      <meta name="og:image" content={baseImageUrl || defaultOGImage} />
      <meta name="og:title" content={pageTitle || "Join Parachute"} />
      <meta name="og:type" content="page" />
      <meta name="twitter:card" content="summary" />
      {siteMetadata?.author && (
        <meta name="twitter:creator" content={siteMetadata.author} />
      )}
      {metaDescription && (
        <meta name="twitter:description" content={metaDescription} />
      )}
      <meta name="twitter:image" content={baseImageUrl || defaultOGImage} />
      <meta name="twitter:title" content={pageTitle || "Join Parachute"} />
      <meta
        name="google-site-verification"
        content="EraMpmlqTYwoat9dSFRRnEkpbZhl0MqPScX2N1yL_bM"
      />
      <link rel="stylesheet" href={googleFontsLink} />
      <noscript>{`
        <link
          href="${googleFontsLink}"
          rel="stylesheet"
          type="text/css"
        />
      `}</noscript>
      <link href={canonical} rel="canonical" />
      <script
        type="text/javascript"
        src="/scripts/onelink-smart-script.js"
      ></script>
      <script
        type="text/javascript"
        src="/scripts/hot-jar-tracking.js"
      ></script>
      <script type="text/javascript" src="/scripts/snap-pixel.js"></script>
      <script
        type="text/javascript"
        src="/scripts/analytics-middleware.js"
        branch={process.env.BRANCH}
      ></script>
      {jsonLD && (
        <script type="application/ld+json">{`
        ${jsonLD}
      `}</script>
      )}
    </>
  )
}

export default SEO
